interface ConvertCurrencyHelper {
  convertCurrency: (
    amount: null | number | string,
    currency: string,
    useFraction?: boolean,
  ) => string;
}

export default function (): ConvertCurrencyHelper {
  function getValidLocale(currency: string) {
    let locale = "";

    switch (true) {
      case currency === "IDR":
        locale = "id-ID";
        break;

      case currency === "VND":
        locale = "vi-VN";
        break;

      case currency === "THB":
        locale = "th-TH";
        break;

      default:
        locale = "id-ID";
        break;
    }

    return locale;
  }

  function convertCurrency(
    amount: null | number | string,
    currency: string,
    useFraction = false,
  ): string {
    if (amount === null) return "-";

    const validCurrency = currency.toUpperCase();
    const locale = getValidLocale(validCurrency);

    const formattedAmount = new Intl.NumberFormat(locale, {
      maximumFractionDigits: useFraction ? 2 : 0,
      minimumFractionDigits: useFraction ? 2 : 0,
    }).format(Number(!isNaN(Number(amount)) ? amount : "0"));

    return `${validCurrency} ${formattedAmount}`;
  }

  return { convertCurrency };
}
